import React from 'react';
import type { SettingsPasswordFormProps } from './SettingsPasswordForm.types';
import { useSettingsPasswordForm } from './SettingsPasswordForm.hook';
import * as styles from './SettingsPasswordForm.styles';

export const SettingsPasswordForm: React.FC<SettingsPasswordFormProps> = (props) => {
  const {
    t,
    currentPassword, setCurrentPassword,
    newPassword, setNewPassword,
    changingPassword,
    handleChangePassword,
  } = useSettingsPasswordForm(props);

  return (
    <form onSubmit={handleChangePassword} className={styles.formContainer}>
      <div className={styles.headerContainer}>
        <h3 className={styles.headerTitle}>{t('security', 'Security Settings')}</h3>
        <p className={styles.headerSubtitle}>{t('securitySubtitle', 'Update your password to secure your account.')}</p>
      </div>

      <div className={styles.inputGroup}>
        <label className={styles.label}>{t('currentPassword', 'Current Password')}</label>
        <input
          type="password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          className={styles.inputClass}
          required
          data-testid="current-password-input"
        />
      </div>

      <div className={styles.inputGroup}>
        <label className={styles.label}>{t('newPassword', 'New Password')}</label>
        <input
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          className={styles.inputClass}
          required
          data-testid="new-password-input"
        />
      </div>

      <div className={styles.footerContainer}>
        <button
          type="submit"
          disabled={changingPassword}
          className={styles.submitButton}
          data-testid="change-password-btn"
        >
          {changingPassword ? <i className={styles.spinnerIcon} /> : null}
          {t('updatePassword', 'Update Password')}
        </button>
      </div>
    </form>
  );
};

export default SettingsPasswordForm;
